module.exports = __webpack_public_path__ + "static/fish-17857c50e2c65f84a1589710cf833f9d.png";